import React, { useState } from "react";
import BillingAddress from "../billingAddress";

interface BillingAddressModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddressSaved: (address: any) => void;
  title?: string;
}

const BillingAddressModal: React.FC<BillingAddressModalProps> = ({ 
  isOpen, 
  onClose, 
  onAddressSaved,
  title = "Add Billing Address"
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAddressSaved = (address: any) => {
    setIsSubmitting(true);
    // Simulate a small delay for better UX
    setTimeout(() => {
      onAddressSaved(address);
      setIsSubmitting(false);
      onClose();
    }, 1000);
  };

  if (!isOpen) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="ti ti-map-pin me-2"></i>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={isSubmitting}
            ></button>
          </div>
          <div className="modal-body">
            <div className="alert alert-info">
              <i className="ti ti-info-circle me-2"></i>
              <strong>Required for Payment:</strong> Please provide your billing address to complete the payment process.
            </div>
            <BillingAddress 
              onAddressSaved={handleAddressSaved}
              showTitle={false}
              className="mt-3"
            />
          </div>
          {/* <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default BillingAddressModal;
